/* eslint-disable no-unused-vars */
/* eslint-disable no-unreachable */
import axios from './index';


/**
 * 用户登录
 * @param {object} params
 */
export function usersLogin(params) {
    return axios({
        method: 'post',
        baseURL: `${process.env.VUE_APP_URL}/api/uc`,
        url:'/students/login',
        data:params
    });
}

/**
 * 获取比赛进度
 * @param {object} params 
 * @param {number} params.competitionId 
 * competitionId
 */
export function getCpProcess(params) {
    return axios.get('/process/student/detail', { params });
}
/**
 * 获取下载证书ui配置
 * @param {object} params 
 * @param {number} params.competitionId 
 * competitionId
 */
export function getCertificate(params) {
    return axios.get(`/portal/certificate/page/setting/${params.competitionId}`);
}
/**
 * 单点登录
 * @param {object} params 
 * competitionId
 */
export function codeLogin(params) {
    return axios({
        method: 'post',
        baseURL: `${process.env.VUE_APP_URL}/api/uc`,
        url:'/stu/identity/retrieve',
        data:params
    });
}

/**
 * 获取学生信息
 * @param {object} params 
 * competitionId
 */
export function getStudentInfo(competitionId) {
    return axios.get(`/enroll/info/${competitionId}`)
}

/**
 * 修改学生信息
 * @param {object} params 
 * competitionId
 */
export function updateStudentInfo(params) {
    return axios.post('/enroll/info/update',params)
}
/**
 * 获取报名信息
 * @param {object} params 
 * competitionId
 */
export function getRegInfo(competitionId) {
    return axios.get(`/module/reg/${competitionId}`)
}
/**
 * 下载pdf证书
 * @param {object} params 
 * 
 */
export function getPdfDownload(params) {
    return axios({
    url: `/certificate/create?processId=${params.processId}`,
    method: 'get',
    responseType: 'blob',
  });
}

/**
 * 序列赛报名
 * @param {obj}
 */
export function serialSignUp(param) {
  return axios.post('/serial/reg',param)
}
 /* 下载pdf活动证明
 * @param {object} params 
 * 
 */
export function getPdfTicketDownload(params) {
    return axios({
    url: `/process/student/ticket/pdf/create?itemId=${params.processId}`,
    method: 'get',
    responseType: 'blob',
  });
}

/**
 * 获取竞赛参赛进展文字
 * @param {string} competitionId:int 竞赛ID
 */
export function getProcessName(params) {
  return axios({
    url: '/process/name',
    method: 'GET',
    params,
  });
}

/**
 * 发送验证码
 * @param {obj} 
 */
 export function sendcode(params,headers={}) {
  return axios({
    url: `${process.env.VUE_APP_URL}/api/uc/comp/stu/sendCode`,
    method: 'GET',
    params,
    headers
  });
}
/**
 * 手机号验证码登录
 * @param {obj}
 */
 export function mobileSmsLogin(param) {
  return axios({
    method: 'post',
    url: `${process.env.VUE_APP_URL}/api/uc/comp/stu/mobileLogin/sms`,
    data: param,
  });
}
/**
 * 手机号验证码登录
 * @param {obj}
 */
 export function mobileLogin(param) {
  return axios({
    method: 'post',
    url: `${process.env.VUE_APP_URL}/api/uc/comp/stu/mobileLogin`,
    data: param,
  });
}

/**
 * 新版本用户登录
 * @param {number} competition 竞赛id
 * @param {string} name 姓名
 * @param {number} identityType 证件类型
 * @param {string} identityValue 证件号码
 * @param {string} verifycode 验证码
 */
export function newStudentLogin(params) {
  // return Promise.resolve({
  //   data: {
  //     token: '1234',
  //     username: '去放风筝',
  //     id: '12345',
  //     avatar: 'https://img.alicdn.com/tfs/TB1Z3Q1XQyWBuNjy0FpXXassXXa-200-200.png',
  //   } 
  // })
  return axios({
    method: 'post',
    baseURL: `${process.env.VUE_APP_URL}/api/competition`,
    url: '/user/public/noc/login',
    data: params,
  })
}

/**
 * 生成图文验证码
 */
export function createVerifyCode() {
  return axios({
    method: 'post',
    url: `${process.env.VUE_APP_URL}/api/uc/comp/stu/imageVerifyCode`,
    responseType: 'blob',
  })
}

/**
 * @param {competitionId}
 */
export function getNocUserInfo(params) {
  return axios({
    method: 'get',
    params,
    url: `${process.env.VUE_APP_URL}/api/competition/noc/signUpData/checkPromoted2024?t=${Date.now()}`,
  })
}